module.exports = __webpack_public_path__ + "assets/img/pulldown_1.bfb25950.svg";